import React from 'react';
import clsx from 'clsx';
import { Button } from '@components/main-components/button/Button';
import {
  updateRecentPageStatus,
  updateUpcomingPageStatus,
} from '@hooks/ReleaseStatus/useReleaseStatus';
import { NAV_LINKS } from '@utils/constants';
import { EmptyStateSVG } from './EmptyStateSVG';
import { FeaturedStatusEnum } from './schema';

export const EmptyState = ({
  type,
  status,
}: {
  type: 'recent' | 'upcoming';
  status: FeaturedStatusEnum;
}) => {
  const showFollowing = status === FeaturedStatusEnum.enum.FOLLOWING;

  return (
    <div className="flex h-[350px] w-full flex-col items-center justify-center rounded-md bg-base50 px-4 py-16 text-center">
      <div className="hidden sm:block">
        <EmptyStateSVG />
      </div>
      <span
        className={clsx(
          'mt-4 font-title text-title-m font-medium text-base900',
          !showFollowing && 'mb-6',
        )}
      >
        It's quiet in here
      </span>
      {showFollowing && (
        <span className="mb-6 mt-2 font-base text-base-m text-base600">
          Your followed artists don't have any {type} drops.
        </span>
      )}
      <Button
        size="M"
        variant="primary"
        label={`View all ${type} drops`}
        href={type === 'recent' ? NAV_LINKS.Recent : NAV_LINKS.Upcoming}
        onClick={() => {
          switch (type) {
            case 'recent': {
              updateRecentPageStatus({
                featuredStatus: 'ALL_DROPS',
              });
              break;
            }
            case 'upcoming': {
              updateUpcomingPageStatus({
                featuredStatus: 'ALL_DROPS',
              });
              break;
            }
          }
        }}
      />
    </div>
  );
};
